import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { getComponentBarChartOption, getTrendLineChartOption } from "../chartConfigs";

export const EDACharts = ({ chart1Data, chart2Data }) => {
  const barChartOption = useMemo(() => getComponentBarChartOption(chart1Data), [chart1Data]);
  const trendChartOption = useMemo(() => getTrendLineChartOption(chart2Data), [chart2Data]);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 mb-5">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-slate-800">Value by Component</h2>
        </div>
        <ReactECharts option={barChartOption} style={{ height: 260 }} notMerge lazyUpdate />
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-slate-800">Value Trend across Mondays</h2>
          <p className="text-sm text-slate-500">Total value per Monday - selected month highlighted</p>
        </div>
        <ReactECharts option={trendChartOption} style={{ height: 260 }} notMerge lazyUpdate />
      </div>
    </div>
  );
};
